import { NotificationDetail } from '../../types';
import { BaseNotificationMessage } from './base-notification-message';
import { EOIPendingMessage } from './eoi-pending-message';
import { EOIAcceptedMessage } from './eoi-accepted-message';
import { EOIRejectedMessage } from './eoi-rejected-message';

interface NotificationMessageProps {
  notification: NotificationDetail;
}

export function NotificationMessage({ notification }: NotificationMessageProps) {
  switch (notification.type) {
    case 'eoi_pending':
      return <EOIPendingMessage notification={notification} />;

    case 'eoi_accepted':
      return <EOIAcceptedMessage notification={notification} />;

    case 'eoi_rejected':
      return <EOIRejectedMessage notification={notification} />;

    default:
      return <BaseNotificationMessage notification={notification}>{notification.title}</BaseNotificationMessage>;
  }
}
